<template>
	<div class="iframe-container">
        <div id="Return_Bar">
            <i class="el-icon-arrow-left"></i>
            <div @click="isreturn" class="isreturn">返回</div>
        </div>
		<iframe 
			:src="iframeSrc" 
			class="iframe-content"
			frameborder="0"
			scrolling="auto"
			@load="onIframeLoad"
		></iframe>
	</div>
</template>

<script>
export default {
	name: 'trainResult',
	data() {
		return {
			trainId: this.$route.query.trainId
		};
	},
    computed: {
        iframeSrc() {
            return "/cloudtraining/customer/trainrecord/trainDeatil?id=" + this.$route.query.trainId
        }
    },
	methods: {
		onIframeLoad() {
			console.log('iframe loaded');
			this.$emit('iframe-loaded');
		},
        isreturn() {
            this.$router.back();
        }
	}
};
</script>

<style lang="less" scoped>
.iframe-container {
	width: 100%;
	height: 100%;
	position: relative;
	overflow: hidden;
}

.iframe-content {
	width: 100%;
	height: 100%;
	border: none;
	display: block;
}

#Return_Bar {
    padding-left: 21px;
    display: flex;
    padding-top: 10px;
    padding-bottom: 15px;
    width: 100%;
}

/deep/.el-icon-arrow-left {
    margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// ./src/page/train/FBT/trainResult.vue